import { api, apiServer } from "../../../api";
import { IBackupTarefaV2 } from "../types";

export const TarefasApi = {
  listarTarefas: async (
    clienteID: string,
    token: string,
    params: {
      q?: string;
      tipo?: string;
      status?: string;
      grupo?: string;
      limit?: number;
      offset?: number;
      ordenarPor?: string;
      direcao?: string;
    }
  ) => {
    let url = `v2/tarefas?clienteID=${clienteID}&limit=${params.limit ?? 10}&offset=${params.offset ?? 0}`;
    if (params.q) {
      url += `&q=${encodeURIComponent(params.q)}`;
    }
    if (params.tipo && params.tipo !== "Todos") {
      url += `&tipo=${params.tipo}`;
    }
    if (params.status && params.status !== "Todos") {
      url += `&status=${params.status}`;
    }
    if (params.grupo && params.grupo !== "Todos") {
      url += `&grupo=${encodeURIComponent(params.grupo)}`;
    }
    if (params.ordenarPor) {
      url += `&ordenarPor=${params.ordenarPor}`;
    }
    if (params.direcao) {
      url += `&direcao=${params.direcao}`;
    }

    const response = await apiServer<{ items: IBackupTarefaV2[]; total: number }>().get(
      url,
      token
    );
    return response.data;
  },

  carregarTarefa: async (tarefaAgendadaID: string, token: string) => {
    const response = await apiServer<IBackupTarefaV2>().get(
      `v2/tarefas/${tarefaAgendadaID}`,
      token
    );
    return response.data;
  },

  criarTarefa: async (tarefa: any, token: string) => {
    const response = await apiServer<{ id: string; tarefaAgendadaID: string; mensagem: string }>().post(
      "v2/tarefas",
      token,
      tarefa
    );
    return response.data;
  },

  alterarTarefa: async (tarefaAgendadaID: string, tarefa: any, token: string) => {
    const response = await api.put<{ tarefaAgendadaID: string; mensagem: string }>(
      `v2/tarefas/${tarefaAgendadaID}`,
      tarefa,
      {
        headers: {
          Authorization: "Basic " + token
        }
      }
    );
    return response.data;
  },

  alterarStatus: async (tarefaAgendadaID: string, status: string, token: string) => {
    const response = await api.patch<{ tarefaAgendadaID: string; mensagem: string }>(
      `v2/tarefas/${tarefaAgendadaID}/status`,
      { status },
      {
        headers: {
          Authorization: "Basic " + token
        }
      }
    );
    return response.data;
  },

  testarConfiguracao: async (tarefaAgendadaID: string, config: any, token: string) => {
    const response = await api.post<{ sucesso: boolean; mensagem: string }>(
      `v2/tarefas/${tarefaAgendadaID}/testar-configuracao`,
      config,
      {
        headers: {
          Authorization: "Basic " + token
        }
      }
    );
    return response.data;
  },

  simularAgendamento: async (
    dadosSimulacao: {
      agendamento: any;
      dataInicio?: Date | string;
      dataFim?: Date | string;
    },
    token: string
  ) => {
    const response = await api.post<{ proximasExecucoes: string[] }>(
      `v2/tarefas/simular-agendamento`,
      dadosSimulacao,
      {
        headers: {
          Authorization: "Basic " + token
        }
      }
    );
    return response.data;
  },

  obterSugestoesBancoDados: async (clienteID: string, token: string) => {
    const response = await apiServer<any[]>().get(
      `v2/config-banco-dados/sugestoes?clienteID=${clienteID}`,
      token
    );
    return response.data;
  },

  executarTarefaRemota: async (tarefaAgendadaID: string, token: string) => {
    const response = await api.post<{ sucesso: boolean; mensagem: string; jaEnfileirada?: boolean; comandoID?: string }>(
      `v2/tarefas/${tarefaAgendadaID}/executar-remoto`,
      {},
      {
        headers: {
          Authorization: "Basic " + token
        }
      }
    );
    return response.data;
  }
};

